import { proxy } from 'valtio'

const enjoyProductChoices = proxy({
  choices: [
    {
      identifier: { name: 'Motorcycles', index: 0 },
      id: [36684],
      testingId: [13692],
      ribNumber: [1, 2, 3, 4, 5, 6, 7],
      midPanel: false,
      badges: [
        { name: 'enjoyMfg', label: 'enjoyMfg', mode: 'enjoyMfg', abrv: 'ENJ' },
        { name: 'Beta', label: 'Beta', mode: 'beta', abrv: 'BET' },
        { name: 'Gasgas', label: 'Gasgas', mode: 'gasgas', abrv: 'GG' },
        { name: 'Honda', label: 'Honda', mode: 'honda', abrv: 'HON' },
        {
          name: 'Husqvarna',
          label: 'Husqvarna',
          mode: 'husqvarna',
          abrv: 'HUS',
        },
        { name: 'Kawasaki', label: 'Kawasaki', mode: 'kawasaki', abrv: 'KAW' },
        { name: 'KTM', label: 'KTM', mode: 'ktm', abrv: 'KTM' },
        { name: 'Suzuki', label: 'Suzuki', mode: 'suzuki', abrv: 'SUZ' },
        { name: 'Yamaha', label: 'Yamaha', mode: 'yamaha', abrv: 'YAM' },
        { name: 'Bolt', label: 'Bolt', mode: 'bolt', abrv: 'BLT' },
        { name: 'None', label: 'None', mode: 'none', abrv: 'None' },
      ],
      newBadge: false,

      make: [
        [
          'Aprilia',
          'APR',
          [
            ['RX 125', [['2021-2024', '457', 7, 'motorcycle', 'large']]],
            ['RXV 450   ', [['2006-2011', '293', 6, 'motorcycle', 'large']]],
            ['SX 125', [['2019-2024', '457', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Beta',
          'BET',
          [
            [
              'RR 125',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 200',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 250',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 300',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 350',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 390',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 430',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RR 480',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RX 300',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RX 450',
              [
                ['2013-2019', '165', 8, 'motorcycle', 'large'],
                ['2020-2025', '204', 7, 'motorcycle', 'large'],
              ],
            ],
          ],
        ],
        [
          'Cobra',
          'COB',
          [
            [
              'CX 50 FWE',
              [
                ['2016-2020', '195', 5, 'motorcycle', 'large'],
                ['2021-2025', '238', 4, 'motorcycle', 'large'],
              ],
            ],
            ['CX 50 JR', [['2010-2025', '151', 4, 'motorcycle', 'large']]],
            [
              'CX 50 KING',
              [
                ['2001-2009', '99', 5, 'motorcycle', 'large'],
                ['2010-2020', '195', 5, 'motorcycle', 'large'],
                ['2021-2023', '238', 4, 'motorcycle', 'large'],
              ],
            ],
            ['CX 50 P3', [['2016-2025', '151', 4, 'motorcycle', 'large']]],
            [
              'CX 65',
              [
                ['2012-2021', '122', 4, 'motorcycle', 'large'],
                ['2022-2025', '429', 5, 'motorcycle', 'large'],
              ],
            ],
          ],
        ],
        [
          'Coleman',
          'COL',
          [
            ['B200R Mini Bike', [['All years', '588', 5, 'scooter', 'large']]],
            ['B200RSV Mini Bike', [['All years', '579', 4, 'scooter', 'large']]],
          ],
        ],
        [
          'Ducati',
          'DUC',
          [
            ['Desmo 250', [['2026', '568', 7, 'motorcycle', 'large']]],
            ['Desmo 450', [['2025-2026', '568', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Fantic',
          'FAN',
          [
            ['TL 125 Enduro', [['2019-2020', '400', 7, 'motorcycle', 'large']]],
            ['TL 125 Motard', [['2019-2020', '400', 7, 'motorcycle', 'large']]],
            ['TL 250', [['2019-2020', '400', 7, 'motorcycle', 'large']]],
            ['TL 50 Enduro', [['2019-2020', '400', 7, 'motorcycle', 'large']]],
            ['XE 50 Enduro', [['2021-2022', '400', 7, 'motorcycle', 'large']]],
            ['XEF 125 Enduro', [['2019-2020', '400', 7, 'motorcycle', 'large']]],
            ['XEF 250 4T Trail Enduro', [['2021-2022', '400', 7, 'motorcycle', 'large']]],
            ['XM 50 Motard', [['2021-2022', '400', 7, 'motorcycle', 'large']]],
            ['XMF 125 Motard', [['2021-2022', '400', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Gasgas',
          'GAS',
          [
            [
              'EC 250',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'EC 300',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'EC 450F',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'ES 350',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'ES 500',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            ['ES 700', [['2023-2025', '412', 8, 'motorcycle', 'large']]],
            [
              'EX 250',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'EX 250F',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'EX 300',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'EX 350F',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 125',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 150',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 250',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 250F',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 300',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 350F',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2025', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 450F',
              [
                ['2021-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '404', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 50',
              [
                ['2021-2023', '144', 4, 'motorcycle', 'large'],
                ['2024-2026', '422', 4, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 65',
              [
                ['2021-2023', '148', 5, 'motorcycle', 'large'],
                ['2024-2026', '426', 5, 'motorcycle', 'large'],
              ],
            ],
            [
              'MC 85',
              [
                ['2021-2024', '161', 7, 'motorcycle', 'large'],
                ['2025-2026', '458', 7, 'motorcycle', 'large'],
              ],
            ],
            ['MC-E 2', [['2024-2026', '431', 4, 'motorcycle', 'large']]],
            ['MC-E 3', [['2022-2024', '144', 4, 'motorcycle', 'large']]],
            ['MC-E 5', [['2022-2024', '144', 4, 'motorcycle', 'large']]],
            ['SM 700', [['2023-2025', '412', 8, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Honda',
          'HON',
          [
            [
              'CBR 600',
              [
                ['1991-1996', '581', 1, 'motorcycle', 'large'],
                ['1997-1998', '580', 0, 'motorcycle', 'large'],
                ['1999-2000', '582', 0, 'motorcycle', 'large'],
              ],
            ],
            [
              'CR 125R',
              [
                ['1993-1997', '119', 6, 'motorcycle', 'large'],
                ['1998-1999', '79', 7, 'motorcycle', 'large'],
                ['2000-2001', '59', 7, 'motorcycle', 'large'],
                ['2002-2008', '55', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'CR 250R',
              [
                ['1992-1996', '119', 6, 'motorcycle', 'large'],
                ['1997-1999', '79', 7, 'motorcycle', 'large'],
                ['2000-2001', '59', 7, 'motorcycle', 'large'],
                ['2002-2008', '55', 7, 'motorcycle', 'large'],
              ],
            ],
            ['CR 85R', [['2002-2008', '95', 6, 'motorcycle', 'large']]],
            ['CRF 100F', [['2004-2013', '138', 6, 'motorcycle', 'large']]],
            [
              'CRF 110F',
              [
                ['2013-2018', '72', 5, 'motorcycle', 'large'],
                ['2019-2026', '234', 5, 'motorcycle', 'large'],
              ],
            ],
            [
              'CRF 125F',
              [
                ['2014-2018', '490', 6, 'motorcycle', 'large'],
                ['2019-2026', '234', 5, 'motorcycle', 'large'],
              ],
            ],
            ['CRF 150F', [['2004-2017', '187', 6, 'motorcycle', 'large']]],
            ['CRF 150R', [['2007-2026', '50', 7, 'motorcycle', 'large']]],
            ['CRF 230F', [['2004-2019', '149', 7, 'motorcycle', 'large']]],
            ['CRF 230L', [['2008-2009', '172', 7, 'motorcycle', 'large']]],
            ['CRF 230M', [['2009-2024', '316', 6, 'motorcycle', 'large']]],
            ['CRF 250F', [['2019-2026', '248', 7, 'motorcycle', 'large']]],
            ['CRF 250L', [['2013-2020', '109', 7, 'motorcycle', 'large']]],
            ['CRF 250LA', [['2017-2020', '109', 7, 'motorcycle', 'large']]],
            [
              'CRF 250R',
              [
                ['2004-2009', '53', 8, 'motorcycle', 'large'],
                ['2010-2013', '45', 8, 'motorcycle', 'large'],
                ['2014-2017', '48', 4, 'motorcycle', 'large'],
                ['2018-2021', '155', 8, 'motorcycle', 'large'],
                ['2022-2026', '233', 6, 'motorcycle', 'large'],
              ],
            ],
            ['CRF 250RL', [['2017-2020', '109', 7, 'motorcycle', 'large']]],
            ['CRF 250RLA', [['2017-2020', '109', 7, 'motorcycle', 'large']]],
            [
              'CRF 250RX',
              [
                ['2019-2021', '155', 8, 'motorcycle', 'large'],
                ['2022-2026', '233', 6, 'motorcycle', 'large'],
              ],
            ],
            [
              'CRF 250X',
              [
                ['2004-2009', '53', 8, 'motorcycle', 'large'],
                ['2012-2017', '53', 8, 'motorcycle', 'large'],
              ],
            ],
            ['CRF 300F', [['2026', '248', 7, 'motorcycle', 'large']]],
            ['CRF 300L', [['2021-2025', '305', 7, 'motorcycle', 'large']]],
            ['CRF 300LA', [['2021-2025', '305', 7, 'motorcycle', 'large']]],
            ['CRF 300LDA', [['2023-2025', '305', 7, 'motorcycle', 'large']]],
            ['CRF 300LR', [['2021-2024', '410', 7, 'motorcycle', 'large']]],
            ['CRF 450L', [['2019-2020', '155', 8, 'motorcycle', 'large']]],
            [
              'CRF 450R',
              [
                ['2002-2004', '58', 9, 'motorcycle', 'large'],
                ['2005-2008', '54', 8, 'motorcycle', 'large'],
                ['2009-2012', '45', 8, 'motorcycle', 'large'],
                ['2013-2016', '48', 4, 'motorcycle', 'large'],
                ['2017-2020', '155', 8, 'motorcycle', 'large'],
                ['2021-2026', '233', 6, 'motorcycle', 'large'],
              ],
            ],
            ['CRF 450RL', [['2021-2026', '155', 8, 'motorcycle', 'large']]],
            [
              'CRF 450RX',
              [
                ['2017-2021', '155', 8, 'motorcycle', 'large'],
                ['2021-2026', '233', 6, 'motorcycle', 'large'],
              ],
            ],
            [
              'CRF 450X',
              [
                ['2005-2017', '101', 7, 'motorcycle', 'large'],
                ['2019-2026', '155', 8, 'motorcycle', 'large'],
              ],
            ],
            ['CRF 50F', [['2004-2026', '106', 4, 'motorcycle', 'large']]],
            ['CRF 70F', [['2004-2012', '128', 5, 'motorcycle', 'large']]],
            ['CRF 80F', [['2004-2013', '138', 6, 'motorcycle', 'large']]],
            ['Cub', [['1990-1996', '186', 5, 'motorcycle', 'large']]],
            ['Dominator NX 250', [['1988-1997', '577', 7, 'motorcycle', 'large']]],
            ['Dominator NX 650', [['1988-1991', '576', 7, 'motorcycle', 'large']]],
            ['QR 50', [['1983-1984', '130', 4, 'motorcycle', 'large']]],
            ['XL 600R', [['1983-1987', '190', 7, 'motorcycle', 'large']]],
            ['XR 100R', [['1985-2003', '511', 6, 'motorcycle', 'large']]],
            ['XR 150L', [['2023-2025', '544', 8, 'motorcycle', 'large']]],
            ['XR 200R', [['1984-2002', '340', 7, 'motorcycle', 'large']]],
            [
              'XR 250',
              [
                ['1979-1982', '411', 6, 'motorcycle', 'large'],
                ['1986-1995', '334', 6, 'motorcycle', 'large'],
                ['1996-2004', '145', 7, 'motorcycle', 'large'],
              ],
            ],
            ['XR 250R', [['1984-1985', '340', 7, 'motorcycle', 'large']]],
            ['XR 400', [['1996-2004', '145', 7, 'motorcycle', 'large']]],
            ['XR 500', [['1981-1982', '299', 5, 'motorcycle', 'large']]],
            ['XR 650L', [['1993-2025', '215', 7, 'motorcycle', 'large']]],
            [
              'XR 70',
              [
                ['1997-2000', '94', 4, 'motorcycle', 'large'],
                ['2001-2003', '125', 4, 'motorcycle', 'large'],
              ],
            ],
            [
              'XR 80',
              [
                ['1993-2000', '94', 4, 'motorcycle', 'large'],
                ['2001-2003', '125', 4, 'motorcycle', 'large'],
              ],
            ],
            ['XR650R', [['2000-2007', '414', 6, 'motorcycle', 'large']]],
            ['Z50', [['1988-1999', '120', 4, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Husqvarna',
          'HUS',
          [
            ['125 TE', [['2015-2016', '113', 7, 'motorcycle', 'large']]],
            [
              '150 TE',
              [
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
                ['2020-2022', '175', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 FC',
              [
                ['2014-2015', '113', 7, 'motorcycle', 'large'],
                ['2016-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2023-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 FE',
              [
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 TE',
              [
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
                ['2020-2022', '175', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 TE',
              [
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
                ['2020-2023', '175', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 TX',
              [
                ['2017-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '350 FC',
              [
                ['2014-2015', '113', 7, 'motorcycle', 'large'],
                ['2016-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2023-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '350 FE',
              [
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
                ['2020-2023', '175', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '350 FX',
              [
                ['2017-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '450 FC',
              [
                ['2014-2015', '113', 7, 'motorcycle', 'large'],
                ['2016-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2023-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '450 FE',
              [
                ['2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '501 FE',
              [
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2019', '134', 7, 'motorcycle', 'large'],
                ['2020-2023', '175', 7, 'motorcycle', 'large'],
                ['2024-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            ['701 ENDURO', [['2016-2025', '182', 7, 'motorcycle', 'large']]],
            ['CR 125 ', [['2006-2008', '191', 7, 'motorcycle', 'large']]],
            ['Norden 901', [['2022-2024', '385', 0, 'motorcycle', 'large']]],
            ['SM400R', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            ['SM450R', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            ['SM510R', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            [
              'SMR, CR, WR',
              [
                ['2004-2008', '69', 7, 'motorcycle', 'large'],
                ['2009-2013', '139', 6, 'motorcycle', 'large'],
              ],
            ],
            [
              'TC 125',
              [
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2016-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2023-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            ['TC 150', [['2026', '329', 7, 'motorcycle', 'large']]],
            [
              'TC 250',
              [
                ['2005-2007', '191', 7, 'motorcycle', 'large'],
                ['2014-2016', '113', 7, 'motorcycle', 'large'],
                ['2017-2018', '134', 7, 'motorcycle', 'large'],
                ['2019-2022', '175', 7, 'motorcycle', 'large'],
                ['2023-2026', '329', 7, 'motorcycle', 'large'],
              ],
            ],
            ['TC 300', [['2026', '329', 7, 'motorcycle', 'large']]],
            ['TC 449', [['2011-2013', '184', 7, 'motorcycle', 'large']]],
            ['TC 450', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            [
              'TC 50',
              [
                ['2017-2023', '164', 5, 'motorcycle', 'large'],
                ['2024-2026', '430', 4, 'motorcycle', 'large'],
              ],
            ],
            ['TC 510', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            ['TC 511', [['2011-2013', '184', 7, 'motorcycle', 'large']]],
            [
              'TC 65',
              [
                ['2017-2023', '156', 6, 'motorcycle', 'large'],
                ['2024-2026', '445', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'TC 85',
              [
                ['2014-2017', '62', 6, 'motorcycle', 'large'],
                ['2018-2024', '168', 8, 'motorcycle', 'large'],
                ['2025-2026', '463', 7, 'motorcycle', 'large'],
              ],
            ],
            ['TCX 449', [['2011-2013', '184', 7, 'motorcycle', 'large']]],
            ['TCX 511', [['2011-2013', '184', 7, 'motorcycle', 'large']]],
            ['TE 250', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            ['TE 449', [['2011-2013', '184', 7, 'motorcycle', 'large']]],
            ['TE 450', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            ['TE 510', [['2005-2007', '191', 7, 'motorcycle', 'large']]],
            ['TE 511', [['2011-2013', '184', 7, 'motorcycle', 'large']]],
            [
              'TE, TC',
              [
                ['2004-2008', '69', 7, 'motorcycle', 'large'],
                ['2009-2013', '139', 6, 'motorcycle', 'large'],
              ],
            ],
            ['WR 125', [['2006-2008', '191', 7, 'motorcycle', 'large']]],
            ['WR 250', [['2006-2013', '191', 7, 'motorcycle', 'large']]],
            ['WR 300', [['2009-2013', '191', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'KTM',
          'KTM',
          [
            ['105 SX', [['2007-2011', '89', 6, 'motorcycle', 'large']]],
            ['105 XC', [['2008-2009', '89', 6, 'motorcycle', 'large']]],
            [
              '125 EGS',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-1999', '123', 7, 'motorcycle', 'large'],
                ['1998-1999', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '125 EXC',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2003-2005', '73', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '125 MXC',
              [
                ['1998-2003', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '125 SX',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2001', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2003-2006', '73', 7, 'motorcycle', 'large'],
                ['2007-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2015', '47', 6, 'motorcycle', 'large'],
                ['2016-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['125 SXS', [['1999-2000', '395', 7, 'motorcycle', 'large']]],
            [
              '125 XC',
              [
                ['2021-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['144 SX', [['2007-2008', '61', 8, 'motorcycle', 'large']]],
            ['150 EXC', [['2022-2023', '173', 7, 'motorcycle', 'large']]],
            [
              '150 SX',
              [
                ['2009-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2015', '47', 6, 'motorcycle', 'large'],
                ['2016-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2025-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '150 XC',
              [
                ['2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2014', '47', 6, 'motorcycle', 'large'],
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '150 XC-W',
              [
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2022', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['150 XC-W TPI', [['2020-2022', '173', 7, 'motorcycle', 'large']]],
            [
              '200 EGS',
              [
                ['1998-1999', '123', 7, 'motorcycle', 'large'],
                ['1998-1999', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '200 EXC',
              [
                ['1996-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2003-2005', '73', 7, 'motorcycle', 'large'],
              ],
            ],
            ['200 Jack Pinner', [['1997', '395', 7, 'motorcycle', 'large']]],
            [
              '200 MXC',
              [
                ['1998-2003', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '200 SX',
              [
                ['1998-2000', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2001-2004', '73', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '200 XC',
              [
                ['2006-2008', '73', 7, 'motorcycle', 'large'],
                ['2009-2011', '61', 8, 'motorcycle', 'large'],
                ['2012-2016', '47', 6, 'motorcycle', 'large'],
              ],
            ],
            [
              '200 XC-W',
              [
                ['2006', '73', 7, 'motorcycle', 'large'],
                ['2007-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2013', '47', 6, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 EGS',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-1999', '123', 7, 'motorcycle', 'large'],
                ['1998-1999', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 EXC',
              [
                ['1996-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2003-2005', '73', 7, 'motorcycle', 'large'],
              ],
            ],
            ['250 EXC-F', [['2017-2019', '173', 7, 'motorcycle', 'large']]],
            ['250 MXC', [['1998-2000', '395', 7, 'motorcycle', 'large']]],
            [
              '250 SX',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2001', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2003-2006', '73', 7, 'motorcycle', 'large'],
                ['2007-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2015', '47', 6, 'motorcycle', 'large'],
                ['2016-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 SXF',
              [
                ['2005-2006', '73', 7, 'motorcycle', 'large'],
                ['2007-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2015', '47', 6, 'motorcycle', 'large'],
                ['2016-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['250 SXS', [['1999-2000', '395', 7, 'motorcycle', 'large']]],
            [
              '250 XC',
              [
                ['2006-2007', '73', 7, 'motorcycle', 'large'],
                ['2008-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2016', '47', 6, 'motorcycle', 'large'],
                ['2017-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 XC-F',
              [
                ['2008-2009', '61', 8, 'motorcycle', 'large'],
                ['2011-2013', '47', 6, 'motorcycle', 'large'],
                ['2017-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 XC-W',
              [
                ['2008-2011', '61', 8, 'motorcycle', 'large'],
                ['2012-2013', '47', 6, 'motorcycle', 'large'],
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '250 XC-W TPI',
              [
                ['2018-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 EGS',
              [
                ['1994-1996', '436', 7, 'motorcycle', 'large'],
                ['1998-1999', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 EXC',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2003-2005', '73', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 MXC',
              [
                ['1994-1997', '436', 7, 'motorcycle', 'large'],
                ['1998-2000', '123', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 SX',
              [
                ['1998-2000', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 XC',
              [
                ['2011-2014', '47', 6, 'motorcycle', 'large'],
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 XC-W',
              [
                ['2008-2011', '61', 8, 'motorcycle', 'large'],
                ['2012-2013', '47', 6, 'motorcycle', 'large'],
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '300 XC-W TPI',
              [
                ['2018-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['350 EGS', [['1994', '436', 7, 'motorcycle', 'large']]],
            ['350 EXC', [['1994', '432', 7, 'motorcycle', 'large']]],
            [
              '350 EXC-F',
              [
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '350 SC',
              [
                ['1994-1995', '432', 7, 'motorcycle', 'large'],
                ['1995-1995', '432', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '350 SXF',
              [
                ['2011-2015', '47', 6, 'motorcycle', 'large'],
                ['2016-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '350 XC-F',
              [
                ['2013', '47', 6, 'motorcycle', 'large'],
                ['2017-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['360 EGS', [['1996-1997', '436', 7, 'motorcycle', 'large']]],
            ['360 EXC / SX', [['1994-1997', '436', 7, 'motorcycle', 'large']]],
            ['360 MXC', [['1996-1997', '436', 7, 'motorcycle', 'large']]],
            [
              '380 EGS',
              [
                ['1998-1999', '395', 7, 'motorcycle', 'large'],
                ['1998', '436', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '380 EXC',
              [
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '380 MXC',
              [
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '380 SX',
              [
                ['1998-2002', '123', 7, 'motorcycle', 'large'],
                ['1998-2000', '395', 7, 'motorcycle', 'large'],
              ],
            ],
            ['380 SXS', [['1999', '395', 7, 'motorcycle', 'large']]],
            ['400 EGS', [['1994-1997', '432', 7, 'motorcycle', 'large']]],
            [
              '400 EXC',
              [
                ['1994-1996', '432', 7, 'motorcycle', 'large'],
                ['2001-2002', '123', 7, 'motorcycle', 'large'],
                ['2003-2005', '73', 7, 'motorcycle', 'large'],
              ],
            ],
            ['400 LC4', [['1998-2000', '326', 7, 'motorcycle', 'large']]],
            ['400 LSE', [['1997', '432', 7, 'motorcycle', 'large']]],
            ['400 MXC', [['2001-2002', '73', 7, 'motorcycle', 'large']]],
            ['400 RXC-E', [['1994-1997', '432', 7, 'motorcycle', 'large']]],
            ['400 SC', [['1994-1995', '432', 7, 'motorcycle', 'large']]],
            ['400 SX', [['2000-2002', '73', 7, 'motorcycle', 'large']]],
            [
              '400 Super Competition SC LC4',
              [['1999-2000', '328', 7, 'motorcycle', 'large']],
            ],
            [
              '400 XC-W',
              [
                ['2007', '73', 7, 'motorcycle', 'large'],
                ['2009-2010', '61', 8, 'motorcycle', 'large'],
              ],
            ],
            ['440 EXC', [['1994-1995', '436', 7, 'motorcycle', 'large']]],
            ['440 MXC', [['1994-1995', '436', 7, 'motorcycle', 'large']]],
            [
              '450 EXC',
              [
                ['2003-2007', '73', 7, 'motorcycle', 'large'],
                ['2009-2011', '61', 8, 'motorcycle', 'large'],
              ],
            ],
            ['450 EXC-F', [['2019-2020', '173', 7, 'motorcycle', 'large']]],
            [
              '450 SMR',
              [
                ['2004-2006', '73', 7, 'motorcycle', 'large'],
                ['2008', '61', 8, 'motorcycle', 'large'],
                ['2021-2022', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '450 SXF',
              [
                ['2003-2006', '73', 7, 'motorcycle', 'large'],
                ['2007-2010', '61', 8, 'motorcycle', 'large'],
                ['2011-2015', '47', 6, 'motorcycle', 'large'],
                ['2016-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '450 XC-F',
              [
                ['2008-2009', '61', 8, 'motorcycle', 'large'],
                ['2013', '47', 6, 'motorcycle', 'large'],
                ['2017-2018', '143', 7, 'motorcycle', 'large'],
                ['2019-2022', '173', 7, 'motorcycle', 'large'],
                ['2023-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              '450 XC-W',
              [
                ['2007', '73', 7, 'motorcycle', 'large'],
                ['2009-2011', '61', 8, 'motorcycle', 'large'],
                ['2012-2013', '47', 6, 'motorcycle', 'large'],
              ],
            ],
            [
              '50 SX',
              [
                ['2000-2001', '107', 4, 'motorcycle', 'large'],
                ['2002-2008', '86', 4, 'motorcycle', 'large'],
                ['2009-2015', '90', 4, 'motorcycle', 'large'],
                ['2016-2023', '144', 4, 'motorcycle', 'large'],
                ['2024-2026', '422', 4, 'motorcycle', 'large'],
              ],
            ],
            ['500 EXC', [['2012-2016', '47', 6, 'motorcycle', 'large']]],
            [
              '500 EXC-F',
              [
                ['2017-2019', '143', 7, 'motorcycle', 'large'],
                ['2020-2023', '173', 7, 'motorcycle', 'large'],
                ['2024-2026', '352', 7, 'motorcycle', 'large'],
              ],
            ],
            ['500 XC-W', [['2013', '47', 6, 'motorcycle', 'large']]],
            ['505 SXF', [['2007-2008', '61', 8, 'motorcycle', 'large']]],
            ['505 XC-F', [['2008-2009', '61', 8, 'motorcycle', 'large']]],
            ['520 EXC', [['2000-2002', '123', 7, 'motorcycle', 'large']]],
            ['520 MXC', [['2001-2002', '73', 7, 'motorcycle', 'large']]],
            ['520 SX', [['2000-2002', '73', 7, 'motorcycle', 'large']]],
            ['525 EXC', [['2003-2005', '73', 7, 'motorcycle', 'large']]],
            ['525 SC', [['2006', '73', 7, 'motorcycle', 'large']]],
            ['525 SMR', [['2004-2005', '73', 7, 'motorcycle', 'large']]],
            ['525 SX', [['2003-2005', '73', 7, 'motorcycle', 'large']]],
            ['525 XC-W', [['2007', '73', 7, 'motorcycle', 'large']]],
            ['530 EXC', [['2008-2011', '61', 8, 'motorcycle', 'large']]],
            ['530 XC-W', [['2009-2011', '61', 8, 'motorcycle', 'large']]],
            ['540 LC4', [['1999', '432', 7, 'motorcycle', 'large']]],
            ['550 MXC', [['1994-1996', '436', 7, 'motorcycle', 'large']]],
            ['560 SMR', [['2006', '73', 7, 'motorcycle', 'large']]],
            ['620 EGS', [['1994-1997', '432', 7, 'motorcycle', 'large']]],
            ['620 EXC', [['1994-1996', '432', 7, 'motorcycle', 'large']]],
            ['620 LC4', [['1998-1999', '326', 7, 'motorcycle', 'large']]],
            ['620 LSE', [['1997', '432', 7, 'motorcycle', 'large']]],
            ['620 RXC-E', [['1995-1997', '432', 7, 'motorcycle', 'large']]],
            ['620 SC', [['1994-1995', '432', 7, 'motorcycle', 'large']]],
            ['620 SX', [['1994-1995', '432', 7, 'motorcycle', 'large']]],
            [
              '620 Super Competition SC LC4',
              [['1999-2001', '328', 7, 'motorcycle', 'large']],
            ],
            ['625 LC4', [['2002', '326', 7, 'motorcycle', 'large']]],
            ['625 SMC', [['2003-2006', '326', 7, 'motorcycle', 'large']]],
            ['640 LC4', [['1998-2000', '326', 7, 'motorcycle', 'large']]],
            [
              '65 SX',
              [
                ['2002-2008', '81', 5, 'motorcycle', 'large'],
                ['2009-2015', '93', 5, 'motorcycle', 'large'],
                ['2016-2023', '148', 5, 'motorcycle', 'large'],
                ['2024-2026', '426', 5, 'motorcycle', 'large'],
              ],
            ],
            [
              '65 XC',
              [
                ['2008', '81', 5, 'motorcycle', 'large'],
                ['2009', '93', 5, 'motorcycle', 'large'],
              ],
            ],
            ['660 EXC', [['1996', '326', 7, 'motorcycle', 'large']]],
            ['660 SMC', [['2003-2005', '326', 7, 'motorcycle', 'large']]],
            ['690 ENDURO', [['2012-2018', '235', 7, 'motorcycle', 'large']]],
            ['690 SMC', [['2008-2010', '235', 7, 'motorcycle', 'large']]],
            ['690 SMC-R', [['2019-2022', '232', 7, 'motorcycle', 'large']]],
            [
              '85 SX',
              [
                ['2006-2012', '89', 6, 'motorcycle', 'large'],
                ['2013-2017', '62', 6, 'motorcycle', 'large'],
                ['2018-2024', '161', 7, 'motorcycle', 'large'],
              ],
            ],
            ['85 XC', [['2008-2009', '89', 6, 'motorcycle', 'large']]],
            ['Duke 200', [['2021-2022', '417', 3, 'motorcycle', 'large']]],
            ['Duke 250', [['2022', '417', 3, 'motorcycle', 'large']]],
            ['Duke 390', [['2018-2022', '417', 3, 'motorcycle', 'large']]],
            ['FREERIDE', [['2016-2025', '262', 7, 'motorcycle', 'large']]],
            ['SX 85', [['2025-2026', '458', 7, 'motorcycle', 'large']]],
            ['SX-E 3', [['2025-2026', '422', 4, 'motorcycle', 'large']]],
            ['SX-E 5', [['2025-2026', '422', 4, 'motorcycle', 'large']]],
            ['SX-E2', [['2025-2026', '431', 4, 'motorcycle', 'large']]],
            ['SX-E3', [['2023-2024', '144', 4, 'motorcycle', 'large']]],
            ['SX-E5', [['2020-2024', '144', 4, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Kawasaki',
          'KAW',
          [
            ['KDX 125', [['1990-1999', '439', 7, 'motorcycle', 'large']]],
            [
              'KDX 200',
              [
                ['1989-1994', '181', 7, 'motorcycle', 'large'],
                ['1995-2006', '85', 7, 'motorcycle', 'large'],
              ],
            ],
            ['KDX 220', [['1997-2006', '85', 7, 'motorcycle', 'large']]],
            ['KLR 250', [['1978-2005', '314', 6, 'motorcycle', 'large']]],
            ['KLR 600', [['1984-1986', '498', 7, 'motorcycle', 'large']]],
            [
              'KLR 650',
              [
                ['1987-2007', '220', 7, 'motorcycle', 'large'],
                ['2008-2018', '304', 7, 'motorcycle', 'large'],
                ['2022-2026', '438', 7, 'motorcycle', 'large'],
              ],
            ],
            ['KLX 110', [['2004-2026', '71', 4, 'motorcycle', 'large']]],
            ['KLX 140', [['2008-2026', '176', 7, 'motorcycle', 'large']]],
            ['KLX 150', [['2015-2025', '516', 7, 'motorcycle', 'large']]],
            ['KLX 230R', [['2020-2024', '371', 7, 'motorcycle', 'large']]],
            [
              'KLX 250',
              [
                ['2006-2008', '117', 7, 'motorcycle', 'large'],
                ['2009-2020', '114', 7, 'motorcycle', 'large'],
              ],
            ],
            ['KLX 300', [['2021-2023', '377', 7, 'motorcycle', 'large']]],
            ['KLX 300R', [['1996-2007', '372', 7, 'motorcycle', 'large']]],
            ['KLX 300SM', [['2021-2023', '377', 7, 'motorcycle', 'large']]],
            ['KLX 650R', [['1993-1996', '515', 8, 'motorcycle', 'large']]],
            [
              'KX 100',
              [
                ['1995-2000', '449', 7, 'motorcycle', 'large'],
                ['2001-2013', '63', 6, 'motorcycle', 'large'],
                ['2014-2021', '83', 6, 'motorcycle', 'large'],
              ],
            ],
            ['KX 112', [['2022-2026', '83', 6, 'motorcycle', 'large']]],
            ['KX 125', [['1986', '453', 7, 'motorcycle', 'large']]],
            [
              'KX 125 (2 Stroke)',
              [
                ['1992-1993', '118', 7, 'motorcycle', 'large'],
                ['1994-1998', '78', 7, 'motorcycle', 'large'],
                ['1999-2002', '77', 7, 'motorcycle', 'large'],
                ['2003-2009', '60', 8, 'motorcycle', 'large'],
              ],
            ],
            ['KX 250', [['1986', '453', 7, 'motorcycle', 'large']]],
            [
              'KX 250 (2 Stroke)',
              [
                ['1992-1993', '118', 7, 'motorcycle', 'large'],
                ['1994-1998', '78', 7, 'motorcycle', 'large'],
                ['1999-2002', '77', 7, 'motorcycle', 'large'],
                ['2003-2009', '60', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'KX 250F',
              [
                ['2004-2005', '64', 8, 'motorcycle', 'large'],
                ['2006-2008', '57', 7, 'motorcycle', 'large'],
                ['2009-2012', '66', 8, 'motorcycle', 'large'],
                ['2013-2016', '65', 8, 'motorcycle', 'large'],
                ['2017-2020', '154', 8, 'motorcycle', 'large'],
                ['2021-2026', '174', 7, 'motorcycle', 'large'],
              ],
            ],
            ['KX 250X', [['2022-2026', '174', 7, 'motorcycle', 'large']]],
            [
              'KX 450F',
              [
                ['2006-2008', '57', 7, 'motorcycle', 'large'],
                ['2009-2011', '66', 8, 'motorcycle', 'large'],
                ['2012-2015', '40', 7, 'motorcycle', 'large'],
                ['2016-2018', '142', 7, 'motorcycle', 'large'],
                ['2019-2026', '174', 7, 'motorcycle', 'large'],
              ],
            ],
            ['KX 450X', [['2024-2026', '174', 7, 'motorcycle', 'large']]],
            [
              'KX 500',
              [
                ['1986', '453', 7, 'motorcycle', 'large'],
                ['1988-2004', '192', 6, 'motorcycle', 'large'],
              ],
            ],
            ['KX 60', [['1983-2003', '115', 4, 'motorcycle', 'large']]],
            ['KX 65', [['2002-2026', '71', 4, 'motorcycle', 'large']]],
            [
              'KX 80',
              [
                ['1988-1990', '450', 6, 'motorcycle', 'large'],
                ['1991-2000', '449', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'KX 85',
              [
                ['2001-2013', '63', 6, 'motorcycle', 'large'],
                ['2014-2026', '83', 6, 'motorcycle', 'large'],
              ],
            ],
          ],
        ],
        [
          'Orion',
          'ORI',
          [['RXB 250X/L Enduro', [['2023-2024', '522', 8, 'motorcycle', 'large']]]],
        ],
        [
          'Pitster',
          'PIT',
          [['PRO FSE 190', [['2020', '483', 6, 'motorcycle', 'large']]]],
        ],
        [
          'Sherco',
          'SHE',
          [
            [
              'SE 125',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'SE 250',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'SE 300',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'SEF 250',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'SEF 300',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'SEF 450',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
            [
              'SEF 500',
              [
                ['2014-2016', '140', 7, 'motorcycle', 'large'],
                ['2017-2025', '166', 8, 'motorcycle', 'large'],
              ],
            ],
          ],
        ],
        [
          'Suzuki',
          'SUZ',
          [
            ['AX 100', [['2015-2019', '524', 3, 'motorcycle', 'large']]],
            ['DL 650 ', [['2004-2011', '398', 0, 'motorcycle', 'large']]],
            ['DR 250', [['1990-2000', '289', 5, 'motorcycle', 'large']]],
            ['DR 350 SE', [['1993-2001', '289', 5, 'motorcycle', 'large']]],
            [
              'DR 650R',
              [
                ['1990-1991', '446', 7, 'motorcycle', 'large'],
                ['1992-1995', '444', 7, 'motorcycle', 'large'],
              ],
            ],
            ['DR 650SE', [['2006-2026', '244', 7, 'motorcycle', 'large']]],
            ['DR-Z4S', [['2025-2026', '517', 7, 'motorcycle', 'large']]],
            ['DRZ 110', [['2003-2005', '71', 4, 'motorcycle', 'large']]],
            ['DRZ 125', [['2003-2026', '170', 8, 'motorcycle', 'large']]],
            ['DRZ 250', [['2001-2019', '169', 8, 'motorcycle', 'large']]],
            ['DRZ 400', [['2000-2018', '70', 7, 'motorcycle', 'large']]],
            ['DS 80', [['1987-2000', '150', 5, 'motorcycle', 'large']]],
            ['JR 50', [['2000-2006', '98', 4, 'motorcycle', 'large']]],
            ['JR 80', [['2001-2015', '198', 5, 'motorcycle', 'large']]],
            [
              'RM 125',
              [
                ['1986-1988', '562', 7, 'motorcycle', 'large'],
                ['1989-1992', '146', 7, 'motorcycle', 'large'],
                ['1993-1995', '80', 8, 'motorcycle', 'large'],
                ['1996-2000', '74', 7, 'motorcycle', 'large'],
                ['2001-2009', '52', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RM 250',
              [
                ['1989-1992', '146', 7, 'motorcycle', 'large'],
                ['1993-1995', '80', 8, 'motorcycle', 'large'],
                ['1996-2000', '74', 7, 'motorcycle', 'large'],
                ['2001-2009', '52', 7, 'motorcycle', 'large'],
              ],
            ],
            ['RM 60', [['2002-2003', '115', 4, 'motorcycle', 'large']]],
            ['RM 65', [['2003-2005', '71', 4, 'motorcycle', 'large']]],
            ['RM 80', [['1996-2001', '135', 5, 'motorcycle', 'large']]],
            ['RM 85', [['2002-2023', '41', 6, 'motorcycle', 'large']]],
            [
              'RMZ 250',
              [
                ['2004-2006', '64', 8, 'motorcycle', 'large'],
                ['2007-2009', '56', 8, 'motorcycle', 'large'],
                ['2010-2018', '49', 7, 'motorcycle', 'large'],
                ['2019-2026', '163', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'RMZ 450',
              [
                ['2005-2007', '298', 7, 'motorcycle', 'large'],
                ['2008-2017', '42', 7, 'motorcycle', 'large'],
                ['2018-2026', '163', 7, 'motorcycle', 'large'],
              ],
            ],
          ],
        ],
        [
          'TM',
          'TM',
          [
            ['125 2T', [['2015-2021', '287', 7, 'motorcycle', 'large']]],
            ['250 2T', [['2015-2021', '287', 7, 'motorcycle', 'large']]],
            ['85 MX', [['2013-2026', '501', 7, 'motorcycle', 'large']]],
            [
              'Racing Model 250/400-450-530',
              [['1999-2003', '264', 7, 'motorcycle', 'large']],
            ],
          ],
        ],
        [
          'Triumph',
          'TRI',
          [
            ['TF 250-C', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 250-E', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 250-X', [['2024-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-C', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-E', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-RC', [['2024-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-X', [['2024-2026', '467', 8, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Yamaha',
          'YAM',
          [
            ['Big Wheel', [['1985-1989', '397', 6, 'motorcycle', 'large']]],
            ['DT 125', [['1978-1981', '335', 6, 'motorcycle', 'large']]],
            ['DT 125X', [['2004-2007', '575', 7, 'motorcycle', 'large']]],
            ['DT 175', [['1978-1981', '335', 6, 'motorcycle', 'large']]],
            ['DT 50', [['2003-2011', '560', 0, 'motorcycle', 'large']]],
            ['DT 80', [['1985-1992', '469', 8, 'motorcycle', 'large']]],
            [
              'IT 175',
              [
                ['1977-1979', '332', 5, 'motorcycle', 'large'],
                ['1982-1983', '336', 5, 'motorcycle', 'large'],
                ['1982-1983', '327', 6, 'motorcycle', 'large'],
              ],
            ],
            ['IT 200', [['1984-1986', '468', 7, 'motorcycle', 'large']]],
            ['IT 250', [['1983-', '306', 5, 'motorcycle', 'large']]],
            ['IT 490', [['1983-1984', '306', 5, 'motorcycle', 'large']]],
            ['MT07', [['2025-2026', '578', 6, 'motorcycle', 'large']]],
            ['MX 175', [['1979-1981', '335', 6, 'motorcycle', 'large']]],
            ['PW 50', [['1981-2026', '91', 4, 'motorcycle', 'large']]],
            ['PW 80', [['1983-2006', '180', 5, 'motorcycle', 'large']]],
            ['RT 180', [['1990-1998', '337', 6, 'motorcycle', 'large']]],
            ['TTR 110', [['2008-2026', '104', 4, 'motorcycle', 'large']]],
            [
              'TTR 125',
              [
                ['2000-2007', '121', 6, 'motorcycle', 'large'],
                ['2008-2026', '147', 6, 'motorcycle', 'large'],
              ],
            ],
            ['TTR 225', [['1999-2004', '103', 6, 'motorcycle', 'large']]],
            ['TTR 230', [['2005-2026', '97', 7, 'motorcycle', 'large']]],
            ['TTR 250', [['1999-2006', '92', 6, 'motorcycle', 'large']]],
            ['TTR 50', [['2004-2026', '105', 4, 'motorcycle', 'large']]],
            ['TTR 90', [['2000-2007', '127', 5, 'motorcycle', 'large']]],
            ['TW 200', [['1987-2026', '271', 7, 'motorcycle', 'large']]],
            [
              'WR 250F',
              [
                ['2001-2006', '76', 8, 'motorcycle', 'large'],
                ['2005-2006', '489', 7, 'motorcycle', 'large'],
                ['2007-2014', '82', 7, 'motorcycle', 'large'],
                ['2007-2013', '136', 7, 'motorcycle', 'large'],
                ['2015-2017', '84', 8, 'motorcycle', 'large'],
                ['2018-2024', '158', 7, 'motorcycle', 'large'],
                ['2025-2026', '375', 7, 'motorcycle', 'large'],
              ],
            ],
            ['WR 250R', [['2008-2020', '110', 6, 'motorcycle', 'large']]],
            ['WR 250X', [['2008-2011', '110', 6, 'motorcycle', 'large']]],
            [
              'WR 450F',
              [
                ['2003-2006', '76', 8, 'motorcycle', 'large'],
                ['2005-2006', '489', 7, 'motorcycle', 'large'],
                ['2007-2011', '82', 7, 'motorcycle', 'large'],
                ['2007-2011', '136', 7, 'motorcycle', 'large'],
                ['2012-2015', '152', 6, 'motorcycle', 'large'],
                ['2016-2018', '84', 8, 'motorcycle', 'large'],
                ['2019-2023', '158', 7, 'motorcycle', 'large'],
                ['2024-2026', '375', 7, 'motorcycle', 'large'],
              ],
            ],
            ['XT 225', [['1986-2007', '241', 6, 'motorcycle', 'large']]],
            [
              'XT 250',
              [
                ['1980-1983', '481', 6, 'motorcycle', 'large'],
                ['2005-2025', '227', 8, 'motorcycle', 'large'],
              ],
            ],
            ['XT 350', [['1985-2000', '284', 6, 'motorcycle', 'large']]],
            ['XT 600', [['1984-1989', '514', 7, 'motorcycle', 'large']]],
            ['XT X 660', [['2004-2017', '345', 6, 'motorcycle', 'large']]],
            ['YZ 100', [['1982-1983', '465', 7, 'motorcycle', 'large']]],
            [
              'YZ 125',
              [
                ['1982-1984', '465', 7, 'motorcycle', 'large'],
                ['1986-1988', '499', 6, 'motorcycle', 'large'],
                ['1988-1990', '179', 6, 'motorcycle', 'large'],
                ['1993-1995', '126', 7, 'motorcycle', 'large'],
                ['1996-2001', '75', 8, 'motorcycle', 'large'],
                ['2002-2021', '67', 7, 'motorcycle', 'large'],
                ['2022-2026', '311', 7, 'motorcycle', 'large'],
              ],
            ],
            ['YZ 125X', [['2023-2026', '311', 7, 'motorcycle', 'large']]],
            [
              'YZ 250',
              [
                ['1979-1981', '384', 5, 'motorcycle', 'large'],
                ['1986-1987', '499', 6, 'motorcycle', 'large'],
                ['1988-1990', '179', 6, 'motorcycle', 'large'],
                ['1993-1995', '126', 7, 'motorcycle', 'large'],
                ['1996-2001', '75', 8, 'motorcycle', 'large'],
                ['2002-2021', '67', 7, 'motorcycle', 'large'],
                ['2022-2026', '311', 7, 'motorcycle', 'large'],
              ],
            ],
            [
              'YZ 250F',
              [
                ['2001-2005', '76', 8, 'motorcycle', 'large'],
                ['2006-2009', '82', 7, 'motorcycle', 'large'],
                ['2010-2013', '88', 7, 'motorcycle', 'large'],
                ['2014-2018', '84', 8, 'motorcycle', 'large'],
                ['2019-2023', '158', 7, 'motorcycle', 'large'],
                ['2024-2026', '375', 7, 'motorcycle', 'large'],
              ],
            ],
            ['YZ 250X', [['2023-2026', '311', 7, 'motorcycle', 'large']]],
            ['YZ 400', [['1979', '384', 5, 'motorcycle', 'large']]],
            ['YZ 400F', [['1998', '76', 8, 'motorcycle', 'large']]],
            ['YZ 426F', [['2000-2002', '76', 8, 'motorcycle', 'large']]],
            [
              'YZ 450F',
              [
                ['2003-2005', '76', 8, 'motorcycle', 'large'],
                ['2006-2009', '82', 7, 'motorcycle', 'large'],
                ['2010-2013', '87', 7, 'motorcycle', 'large'],
                ['2014-2017', '84', 8, 'motorcycle', 'large'],
                ['2018-2022', '158', 7, 'motorcycle', 'large'],
                ['2023-2026', '375', 7, 'motorcycle', 'large'],
              ],
            ],
            ['YZ 465', [['1980-1981', '384', 5, 'motorcycle', 'large']]],
            ['YZ 490', [['1986-1990', '499', 6, 'motorcycle', 'large']]],
            ['YZ 65', [['2018-2026', '188', 6, 'motorcycle', 'large']]],
            ['YZ 80', [['1993-2001', '124', 6, 'motorcycle', 'large']]],
            ['YZ 80 ', [['1982', '583', 4, 'motorcycle', 'large']]],
            [
              'YZ 85',
              [
                ['2002-2021', '96', 7, 'motorcycle', 'large'],
                ['2022-2026', '319', 6, 'motorcycle', 'large'],
              ],
            ],
          ],
        ],
      ],
    },

    {
      identifier: { name: 'ATVs', index: 1 },

      id: [36686],
      testingId: [13694],
      // testing
      //    id: [
      //   [
      //     73409, 73401, 73411, 73403, 73408, 73400, 73407, 73399, 73410, 73402, 73412,
      //     73404, 73414, 73406, 73413, 73405,
      //   ],
      // ],
      ribNumber: [1, 2, 3, 4, 5, 6],
      midPanel: false,
      badges: [
        { name: 'enjoyMfg', label: 'enjoyMfg', mode: 'enjoyMfg', abrv: 'ENJ' },
        {
          name: 'Arctic Cat',
          label: 'Arctic Cat',
          mode: 'arcticcat',
          abrv: 'ARTC',
        },
        { name: 'Can-Am', label: 'Can-Am', mode: 'canam', abrv: 'CAM' },
        { name: 'Honda', label: 'Honda', mode: 'honda', abrv: 'HON' },
        { name: 'Kawasaki', label: 'Kawasaki', mode: 'kawasaki', abrv: 'KAW' },
        { name: 'KTM', label: 'KTM', mode: 'ktm', abrv: 'KTM' },
        { name: 'Suzuki', label: 'Suzuki', mode: 'suzuki', abrv: 'SUZ' },
        { name: 'Yamaha', label: 'Yamaha', mode: 'yamaha', abrv: 'YAM' },
        { name: 'Polaris', label: 'Polaris', mode: 'polaris', abrv: 'POL' },
        { name: 'Bolt', label: 'Bolt', mode: 'bolt', abrv: 'BLT' },
        { name: 'None', label: 'None', mode: 'none', abrv: 'None' },
      ],
      make: [
        [
          'Arctic Cat',
          'ARTC',
          [
            ['1000', [['2010-2017', '368', 6, 'atv', 'large']]],
            ['1000 TRV', [['2009-2017', '368', 6, 'atv', 'large']]],
            ['250', [['1999-2003', '219', 0, 'atv', 'large']]],
            ['250 DVX', [['2006-2008', '427', 7, 'atv', 'large']]],
            ['250 Utility', [['2006-2009', '277', 6, 'atv', 'large']]],
            ['2x4', [['1997', '219', 0, 'atv', 'large']]],
            ['300', [['1998-2003', '219', 0, 'atv', 'large']]],
            ['300 DVX', [['2009-2015', '427', 7, 'atv', 'large']]],
            ['300 Utility', [['2010-2016', '277', 6, 'atv', 'large']]],
            ['375 2x4', [['2002', '451', 7, 'atv', 'large']]],
            [
              '400',
              [
                ['1998-2001', '219', 0, 'atv', 'large'],
                ['2006-2008', '380', 6, 'atv', 'large'],
              ],
            ],
            ['400 Automatic 4x4 TBX', [['2005', '380', 6, 'atv', 'large']]],
            ['400 DVX', [['2004-2008', '253', 7, 'atv', 'large']]],
            [
              '400 FIS',
              [
                ['2002-2005', '451', 7, 'atv', 'large'],
                ['2006-2008', '387', 6, 'atv', 'large'],
              ],
            ],
            ['400 TBX', [['2005-2006', '387', 6, 'atv', 'large']]],
            ['400 TRV', [['2006-2008', '387', 6, 'atv', 'large']]],
            ['400 VP', [['2006', '387', 6, 'atv', 'large']]],
            ['450', [['2012', '387', 6, 'atv', 'large']]],
            ['450 EFI', [['2011', '387', 6, 'atv', 'large']]],
            ['454', [['1998', '219', 0, 'atv', 'large']]],
            ['4x4', [['1997', '219', 0, 'atv', 'large']]],
            ['50 Utility DVX', [['2006-2008', '325', 5, 'atv', 'large']]],
            ['50 Youth', [['2004-2005', '256', 5, 'atv', 'large']]],
            [
              '500',
              [
                ['1998-2001', '219', 0, 'atv', 'large'],
                ['2005-2008', '380', 6, 'atv', 'large'],
                ['2008-2009', '368', 6, 'atv', 'large'],
                ['2013-2017', '387', 6, 'atv', 'large'],
              ],
            ],
            ['500 Auto', [['2002', '451', 7, 'atv', 'large']]],
            [
              '500 FIS',
              [
                ['2002-2004', '451', 7, 'atv', 'large'],
                ['2005-2009', '387', 6, 'atv', 'large'],
              ],
            ],
            ['500 TBX', [['2005-2006', '387', 6, 'atv', 'large']]],
            ['500 TRV', [['2006-2008', '387', 6, 'atv', 'large']]],
            [
              '550',
              [
                ['2009-2010', '368', 6, 'atv', 'large'],
                ['2012-2015', '387', 6, 'atv', 'large'],
              ],
            ],
            ['550 H1', [['2011', '387', 6, 'atv', 'large']]],
            ['550s H1', [['2010-2011', '387', 6, 'atv', 'large']]],
            ['650 H1', [['2005-2012', '387', 6, 'atv', 'large']]],
            ['650 H1, V2', [['2005-2010', '380', 6, 'atv', 'large']]],
            ['650 TBX, TRV Low Profile', [['2009-2010', '368', 6, 'atv', 'large']]],
            ['650 V-2 / V-TWIN', [['2005-2006', '387', 6, 'atv', 'large']]],
            ['650V-2 FIS', [['2004', '451', 7, 'atv', 'large']]],
            ['700 4X4', [['2007-2017', '387', 6, 'atv', 'large']]],
            ['700 EFI Auto', [['2006-2010', '380', 6, 'atv', 'large']]],
            ['700 H1, TRV Low Profile', [['2008-2010', '368', 6, 'atv', 'large']]],
            ['700s H1', [['2010-2011', '387', 6, 'atv', 'large']]],
            ['90 DVX', [['2008-2019', '325', 5, 'atv', 'large']]],
            ['90 Utility', [['2006-2016', '325', 5, 'atv', 'large']]],
            ['90 Youth', [['2002-2005', '256', 5, 'atv', 'large']]],
            ['Alterra 400', [['2016-2017', '364', 5, 'atv', 'large']]],
            ['Alterra 450', [['2016-2024', '364', 5, 'atv', 'large']]],
            [
              'Alterra 500',
              [
                ['2016', '379', 7, 'atv', 'large'],
                ['2017-2018', '364', 5, 'atv', 'large'],
                ['2017-2020', '387', 6, 'atv', 'large'],
              ],
            ],
            ['Alterra 550', [['2017', '387', 6, 'atv', 'large']]],
            ['Alterra 550 XT', [['2016', '379', 7, 'atv', 'large']]],
            ['Alterra 570', [['2019-2021', '379', 7, 'atv', 'large']]],
            ['Alterra 700', [['2017-2022', '387', 6, 'atv', 'large']]],
            ['Alterra 700 (NOT TRV OR TBX)', [['2016-2021', '379', 7, 'atv', 'large']]],
            ['Alterra 90', [['2017-2024', '325', 5, 'atv', 'large']]],
            ['Bearcat 4x4', [['1996', '219', 0, 'atv', 'large']]],
            ['Thundercat', [['2008-2010', '368', 6, 'atv', 'large']]],
            ['XR 500', [['2015', '379', 7, 'atv', 'large']]],
            ['XR 550', [['2015', '379', 7, 'atv', 'large']]],
            ['XR 700', [['2015', '379', 7, 'atv', 'large']]],
          ],
        ],
        [
          'Bombardier',
          'BOM',
          [
            ['Quest Max 650', [['2004', '518', 0, 'atv', 'large']]],
            ['Traxter 500', [['1999-2005', '519', 0, 'atv', 'large']]],
            ['Traxter 650', [['1999-2005', '519', 0, 'atv', 'large']]],
            ['Traxter Max', [['2003-2005', '518', 0, 'atv', 'large']]],
          ],
        ],
        [
          'Can-Am',
          'CAN',
          [
            ['DS 250', [['2006-2025', '263', 6, 'atv', 'large']]],
            ['DS 450', [['2008-2015', '257', 7, 'atv', 'large']]],
            ['DS 650', [['2000-2007', '258', 7, 'atv', 'large']]],
            ['DS 70', [['2008-2022', '259', 5, 'atv', 'large']]],
            ['DS 90', [['2008-2022', '259', 5, 'atv', 'large']]],
            [
              'Outlander 1000',
              [
                ['2012-2024', '292', 6, 'atv', 'large'],
                ['2013-2024', '360', 6, 'atv', 'large'],
              ],
            ],
            ['Outlander 330', [['2004-2005', '341', 7, 'atv', 'large']]],
            ['Outlander 400', [['2003-2014', '341', 7, 'atv', 'large']]],
            [
              'Outlander 450',
              [
                ['2015-2024', '360', 6, 'atv', 'large'],
                ['2017-2023', '292', 6, 'atv', 'large'],
              ],
            ],
            [
              'Outlander 500',
              [
                ['2007-2012', '297', 7, 'atv', 'large'],
                ['2013-2014', '292', 6, 'atv', 'large'],
                ['2013-2015', '360', 6, 'atv', 'large'],
                ['2023-2025', '408', 6, 'atv', 'large'],
              ],
            ],
            [
              'Outlander 570',
              [
                ['2016-2023', '360', 6, 'atv', 'large'],
                ['2017-2023', '292', 6, 'atv', 'large'],
              ],
            ],
            [
              'Outlander 650',
              [
                ['2006-2012', '297', 7, 'atv', 'large'],
                ['2013-2018', '292', 6, 'atv', 'large'],
                ['2013-2024', '360', 6, 'atv', 'large'],
              ],
            ],
            ['Outlander 700', [['2023-2025', '408', 6, 'atv', 'large']]],
            [
              'Outlander 800',
              [
                ['2007-2011', '297', 7, 'atv', 'large'],
                ['2012-2014', '292', 6, 'atv', 'large'],
              ],
            ],
            ['Outlander 800R STD, XT', [['2012-2015', '360', 6, 'atv', 'large']]],
            ['Outlander 850', [['2017-2024', '292', 6, 'atv', 'large']]],
            ['Outlander DPS 500', [['2023', '408', 6, 'atv', 'large']]],
            ['Outlander DPS 700', [['2023', '408', 6, 'atv', 'large']]],
            ['Outlander Max 1000', [['2013-2025', '292', 6, 'atv', 'large']]],
            ['Outlander Max 450', [['2018-2025', '292', 6, 'atv', 'large']]],
            [
              'Outlander Max 500',
              [
                ['2007-2012', '297', 7, 'atv', 'large'],
                ['2013-2014', '292', 6, 'atv', 'large'],
              ],
            ],
            ['Outlander Max 570', [['2018-2022', '292', 6, 'atv', 'large']]],
            [
              'Outlander Max 650',
              [
                ['2006-2012', '297', 7, 'atv', 'large'],
                ['2013-2025', '292', 6, 'atv', 'large'],
              ],
            ],
            [
              'Outlander Max 800',
              [
                ['2006-2012', '297', 7, 'atv', 'large'],
                ['2014', '292', 6, 'atv', 'large'],
              ],
            ],
            ['Outlander Max 850', [['2018-2024', '292', 6, 'atv', 'large']]],
            ['Outlander Pro HD5', [['2023-2025', '408', 6, 'atv', 'large']]],
            ['Outlander Pro HD7', [['2023-2025', '408', 6, 'atv', 'large']]],
            ['Outlander X MR 700', [['2023-2025', '408', 6, 'atv', 'large']]],
            ['Quest Max 650', [['2004', '518', 0, 'atv', 'large']]],
            ['Rally 175', [['2003-2007', '369', 5, 'atv', 'large']]],
            [
              'Renegade 1000',
              [
                ['2007-2014', '260', 6, 'atv', 'large'],
                ['2012-2024', '294', 6, 'atv', 'large'],
              ],
            ],
            [
              'Renegade 500',
              [
                ['2013-2015', '260', 6, 'atv', 'large'],
                ['2013-2017', '294', 6, 'atv', 'large'],
              ],
            ],
            [
              'Renegade 570',
              [
                ['2018-2022', '260', 6, 'atv', 'large'],
                ['2018-2022', '394', 7, 'atv', 'large'],
              ],
            ],
            [
              'Renegade 650',
              [
                ['2019-2024', '294', 6, 'atv', 'large'],
                ['2023-2024', '260', 6, 'atv', 'large'],
              ],
            ],
            ['Renegade 650 T3', [['2018-2020', '294', 6, 'atv', 'large']]],
            [
              'Renegade 800',
              [
                ['2012-2017', '260', 6, 'atv', 'large'],
                ['2012-2017', '294', 6, 'atv', 'large'],
              ],
            ],
            [
              'Renegade 850',
              [
                ['2018-2022', '260', 6, 'atv', 'large'],
                ['2018-2022', '294', 6, 'atv', 'large'],
              ],
            ],
            ['Traxter 500', [['1999-2005', '519', 0, 'atv', 'large']]],
            ['Traxter 650', [['1999-2005', '519', 0, 'atv', 'large']]],
            ['Traxter Max', [['2003-2005', '518', 0, 'atv', 'large']]],
          ],
        ],
        [
          'Honda',
          'HON',
          [
            ['ATC 200ES', [['1984', '526', 4, 'atv', 'large']]],
            ['ATC 200M', [['1984-1985', '526', 4, 'atv', 'large']]],
            ['ATC 200X', [['1983-1985', '276', 6, 'atv', 'large']]],
            ['ATC 250ES', [['1985-1987', '527', 4, 'atv', 'large']]],
            [
              'ATC 250R',
              [
                ['1983-1984', '513', 6, 'atv', 'large'],
                ['1985-1986', '278', 5, 'atv', 'large'],
              ],
            ],
            ['TRX 125 Fourtrax', [['1985-1986', '274', 5, 'atv', 'large']]],
            ['TRX 200', [['1984', '275', 6, 'atv', 'large']]],
            ['TRX 200 SX Fourtrax', [['1986-1998', '282', 6, 'atv', 'large']]],
            ['TRX 250 Recon', [['1997-2004', '250', 6, 'atv', 'large']]],
            ['TRX 250EX', [['2001-2005', '210', 7, 'atv', 'large']]],
            ['TRX 250EX Sportrax 250EX', [['2006-2008', '206', 6, 'atv', 'large']]],
            ['TRX 250R Fourtrax 250R22', [['1986-1989', '205', 7, 'atv', 'large']]],
            ['TRX 250X Fourtrax 250X', [['1987-1988', '484', 7, 'atv', 'large']]],
            ['TRX 300A Fourtrax', [['1988-2000', '273', 6, 'atv', 'large']]],
            ['TRX 300EX', [['1993-2006', '208', 7, 'atv', 'large']]],
            ['TRX 300FWA Fourtrax', [['1988-2000', '273', 6, 'atv', 'large']]],
            ['TRX 350 FE', [['2000-2006', '355', 6, 'atv', 'large']]],
            ['TRX 350 FM', [['2000-2006', '355', 6, 'atv', 'large']]],
            ['TRX 350 Fourtrax', [['1986-1987', '506', 6, 'atv', 'large']]],
            ['TRX 350 Fourtrax Foreman', [['1987-1989', '506', 6, 'atv', 'large']]],
            ['TRX 350 TE', [['2000-2006', '355', 6, 'atv', 'large']]],
            ['TRX 350 TM', [['2000-2006', '355', 6, 'atv', 'large']]],
            ['TRX 400 FA', [['2004-2007', '355', 6, 'atv', 'large']]],
            ['TRX 400 FG', [['2004-2007', '355', 6, 'atv', 'large']]],
            [
              'TRX 400EX',
              [
                ['1999-2007', '203', 6, 'atv', 'large'],
                ['2008', '202', 6, 'atv', 'large'],
              ],
            ],
            ['TRX 400X', [['2009-2014', '202', 6, 'atv', 'large']]],
            ['TRX 420 FA ForeTrax Rancher', [['2015-2025', '454', 5, 'atv', 'large']]],
            ['TRX 420 FM ForeTrax Rancher', [['2015-2025', '454', 5, 'atv', 'large']]],
            ['TRX 450ER', [['2004-2014', '197', 7, 'atv', 'large']]],
            ['TRX 450R', [['2004-2014', '197', 7, 'atv', 'large']]],
            ['TRX 500 FA Foreman Rubicon', [['2005-2014', '223', 6, 'atv', 'large']]],
            ['TRX 500 FA5', [['2015-2019', '370', 6, 'atv', 'large']]],
            ['TRX 500 FA6', [['2015-2019', '370', 6, 'atv', 'large']]],
            ['TRX 500 FA7', [['2015-2019', '370', 6, 'atv', 'large']]],
            ['TRX 500 FE 1 ForeTrax Foreman', [['2015-2016', '454', 5, 'atv', 'large']]],
            ['TRX 500 FE 2 ForeTrax Foreman', [['2015-2019', '454', 5, 'atv', 'large']]],
            ['TRX 500 FE Fourtrax Foreman', [['2005-2011', '223', 6, 'atv', 'large']]],
            ['TRX 500 FM 1 ForeTrax Foreman', [['2015-2019', '454', 5, 'atv', 'large']]],
            ['TRX 500 FM 2 ForeTrax Foreman', [['2020-2025', '454', 5, 'atv', 'large']]],
            ['TRX 500 FM Fourtrax Foreman', [['2005-2011', '223', 6, 'atv', 'large']]],
            ['TRX 500 FM5', [['2015-2018', '370', 6, 'atv', 'large']]],
            ['TRX 500 FM6', [['2015-2019', '370', 6, 'atv', 'large']]],
            ['TRX 500 FM7', [['2015-2017', '370', 6, 'atv', 'large']]],
            [
              'TRX 500 FPA Fourtrax Foreman Rubicon',
              [['2009-2013', '223', 6, 'atv', 'large']],
            ],
            ['TRX 500 FPE Foreman', [['2007-2011', '223', 6, 'atv', 'large']]],
            ['TRX 500 FPM Foreman', [['2008-2011', '223', 6, 'atv', 'large']]],
            [
              'TRX 500 Foretrax Foreman Rubicon',
              [['2001-2004', '226', 5, 'atv', 'large']],
            ],
            ['TRX 520 FA', [['2020-2024', '370', 6, 'atv', 'large']]],
            ['TRX 520 FE 2 ForeTrax Foreman', [['2020-2025', '454', 5, 'atv', 'large']]],
            ['TRX 520 FM 1 ForeTrax Foreman', [['2020-2025', '454', 5, 'atv', 'large']]],
            ['TRX 520 FM 2 ForeTrax Foreman', [['2020-2025', '454', 5, 'atv', 'large']]],
            ['TRX 650FA Fourtrax Rincon', [['2003-2005', '416', 6, 'atv', 'large']]],
            ['TRX 650FG Fourtrax Rincon', [['2004-2005', '416', 6, 'atv', 'large']]],
            ['TRX 680 FG Fourtrax Rincon', [['2006-2009', '416', 6, 'atv', 'large']]],
            ['TRX 680FA Fourtrax Rincon', [['2006-2023', '416', 6, 'atv', 'large']]],
            ['TRX 70 Fourtrax', [['1986-1987', '279', 4, 'atv', 'large']]],
            ['TRX 700', [['2008-2009', '239', 7, 'atv', 'large']]],
            ['TRX 700 FA Fourtrax Rubicon', [['2024-2025', '416', 6, 'atv', 'large']]],
            [
              'TRX 90',
              [
                ['1993-2005', '247', 6, 'atv', 'large'],
                ['2006-2024', '211', 5, 'atv', 'large'],
              ],
            ],
          ],
        ],
        [
          'John Deere',
          'JOH',
          [
            ['Buck 500', [['2005-2006', '519', 0, 'atv', 'large']]],
            ['Buck 650', [['2005-2006', '519', 0, 'atv', 'large']]],
          ],
        ],
        [
          'KTM',
          'KTM',
          [
            ['SXF 450', [['2008-2009', '324', 7, 'atv', 'large']]],
            ['SXF 525', [['2008-2009', '324', 7, 'atv', 'large']]],
            ['XC 450', [['2008-2009', '324', 7, 'atv', 'large']]],
            ['XC 525', [['2008-2009', '324', 7, 'atv', 'large']]],
          ],
        ],
        [
          'Kawasaki',
          'KAW',
          [
            ['Bayou 220', [['1988-2002', '222', 0, 'atv', 'large']]],
            ['Bayou 250', [['2003-2011', '222', 0, 'atv', 'large']]],
            ['Bayou KLF 300 2x4', [['1986-2004', '224', 0, 'atv', 'large']]],
            ['Brute Force 300', [['2012-2025', '291', 6, 'atv', 'large']]],
            ['Brute Force 650 4x4', [['2005-2009', '374', 7, 'atv', 'large']]],
            ['Brute Force 650 4x4i', [['2006-2013', '339', 8, 'atv', 'large']]],
            ['Brute Force 750 4x4i', [['2005-2023', '339', 8, 'atv', 'large']]],
            ['KFX 400', [['2003-2006', '207', 7, 'atv', 'large']]],
            ['KFX 450R', [['2008-2014', '229', 7, 'atv', 'large']]],
            ['KFX 50', [['2007-2024', '317', 5, 'atv', 'large']]],
            ['KFX 700', [['2004-2011', '231', 7, 'atv', 'large']]],
            ['KFX 80', [['2003-3006', '213', 5, 'atv', 'large']]],
            ['KFX 90', [['2007-2024', '317', 5, 'atv', 'large']]],
            ['KLF 300 4X4 Bayou', [['1989-2005', '281', 0, 'atv', 'large']]],
            ['KLF 400 4x4 Bayou', [['1993+-1999', '281', 0, 'atv', 'large']]],
            ['Lakota 300 (KEF300)', [['1995-2003', '283', 7, 'atv', 'large']]],
            ['Mojave 250 (KSF250)', [['1987-2004', '283', 7, 'atv', 'large']]],
            ['Prairie 300', [['1999-2002', '338', 6, 'atv', 'large']]],
            ['Prairie 400', [['1997-2002', '338', 6, 'atv', 'large']]],
            ['Prairie KVF 650 4x4', [['2002-2003', '374', 7, 'atv', 'large']]],
            ['Prairie KVF 700 4x4', [['2004-2005', '374', 7, 'atv', 'large']]],
            ['Tecate 4 KXF 250', [['1987-1988', '286', 6, 'atv', 'large']]],
            ['Tecate KXT 250', [['1984-1985', '280', 5, 'atv', 'large']]],
          ],
        ],
        [
          'Kymco',
          'KYM',
          [
            ['MXU 250', [['2004-2016', '277', 6, 'atv', 'large']]],
            ['MXU 300', [['2005-2012', '277', 6, 'atv', 'large']]],
            ['Mongoose 250', [['2004-2009', '302', 5, 'atv', 'large']]],
            ['Mongoose 300', [['2006-2015', '302', 5, 'atv', 'large']]],
          ],
        ],
        [
          'Polaris',
          'POL',
          [
            ['ATP 330', [['2004-2005', '269', 7, 'atv', 'large']]],
            ['ATP 500', [['2004-2005', '269', 7, 'atv', 'large']]],
            [
              'Diesel',
              [
                ['1999-2001', '218', 7, 'atv', 'large'],
                ['1999-2001', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Hawkeye', [['2006-2011', '539', 7, 'atv', 'large']]],
            ['Hawkeye 300', [['2006-2011', '487', 6, 'atv', 'large']]],
            [
              'Hawkeye 400',
              [
                ['2011-2014', '218', 7, 'atv', 'large'],
                ['2011-2014', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'INTL Diesel',
              [
                ['1999', '218', 7, 'atv', 'large'],
                ['1999', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Magnum 325',
              [
                ['2001-2002', '218', 7, 'atv', 'large'],
                ['2001-2002', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Magnum 330',
              [
                ['2003-2005', '218', 7, 'atv', 'large'],
                ['2003-2005', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Magnum 500',
              [
                ['1999-2003', '218', 7, 'atv', 'large'],
                ['1999-2003', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Outlaw 110', [['2016-2025', '252', 7, 'atv', 'large']]],
            [
              'Outlaw 450',
              [
                ['2008', '255', 7, 'atv', 'large'],
                ['2009-2010', '251', 7, 'atv', 'large'],
              ],
            ],
            ['Outlaw 50', [['2008-2019', '254', 5, 'atv', 'large']]],
            ['Outlaw 500', [['2006-2008', '255', 7, 'atv', 'large']]],
            [
              'Outlaw 525',
              [
                ['2007-2008', '255', 7, 'atv', 'large'],
                ['2009-2011', '251', 7, 'atv', 'large'],
              ],
            ],
            ['Outlaw 90', [['2007-2016', '252', 7, 'atv', 'large']]],
            ['Phoenix 200', [['2005-2026', '267', 7, 'atv', 'large']]],
            [
              'Predator 500',
              [
                ['2003-2007', '225', 7, 'atv', 'large'],
                ['2004-2007', '254', 5, 'atv', 'large'],
              ],
            ],
            ['Predator 90', [['2004-2006', '228', 6, 'atv', 'large']]],
            ['Sawtooth 200', [['2006-2007', '267', 7, 'atv', 'large']]],
            ['Scrabler 850 XP', [['2013-2017', '347', 6, 'atv', 'large']]],
            ['Scrambler 1000', [['2014-2017', '347', 6, 'atv', 'large']]],
            ['Scrambler 2x4 INTL', [['2008-2009', '243', 7, 'atv', 'large']]],
            ['Scrambler 2x4 INTL 500', [['2009', '313', 6, 'atv', 'large']]],
            ['Scrambler 400L', [['1995-2002', '243', 7, 'atv', 'large']]],
            [
              'Scrambler 500',
              [
                ['1995-2009', '243', 7, 'atv', 'large'],
                ['2004-2009', '313', 6, 'atv', 'large'],
              ],
            ],
            ['Sportsman 1000 XP', [['2017-2021', '333', 6, 'atv', 'large']]],
            [
              'Sportsman 300',
              [
                ['2008-2010', '487', 6, 'atv', 'large'],
                ['2008-2010', '539', 7, 'atv', 'large'],
              ],
            ],
            [
              'Sportsman 325',
              [
                ['1999-2000', '218', 7, 'atv', 'large'],
                ['1999-2000', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Sportsman 400',
              [
                ['2001-2005', '218', 7, 'atv', 'large'],
                ['2001-2005', '350', 8, 'atv', 'large'],
                ['2008-2010', '487', 6, 'atv', 'large'],
                ['2011-2014', '218', 7, 'atv', 'large'],
                ['2011-2014', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Sportsman 400 HO', [['2008-2010', '539', 7, 'atv', 'large']]],
            [
              'Sportsman 450',
              [
                ['2006-2007', '218', 7, 'atv', 'large'],
                ['2006-2007', '350', 8, 'atv', 'large'],
                ['2016-2024', '343', 7, 'atv', 'large'],
              ],
            ],
            [
              'Sportsman 500',
              [
                ['1996-2013', '218', 7, 'atv', 'large'],
                ['1996-2013', '350', 8, 'atv', 'large'],
                ['2005-2013', '342', 7, 'atv', 'large'],
              ],
            ],
            [
              'Sportsman 500 Forest',
              [
                ['2011-2013', '218', 7, 'atv', 'large'],
                ['2011-2013', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Sportsman 550', [['2012-2013', '296', 7, 'atv', 'large']]],
            ['Sportsman 550 EPS', [['2012-2014', '296', 7, 'atv', 'large']]],
            ['Sportsman 570', [['2015-2024', '343', 7, 'atv', 'large']]],
            [
              'Sportsman 600',
              [
                ['2004', '269', 7, 'atv', 'large'],
                ['2005', '218', 7, 'atv', 'large'],
                ['2005', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Sportsman 700',
              [
                ['2004', '269', 7, 'atv', 'large'],
                ['2005-2007', '218', 7, 'atv', 'large'],
                ['2005-2007', '342', 7, 'atv', 'large'],
                ['2005-2007', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Sportsman 800',
              [
                ['2005-2015', '218', 7, 'atv', 'large'],
                ['2005-2008', '342', 7, 'atv', 'large'],
                ['2005-2015', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Sportsman 850 High Lifter', [['2016-2019', '296', 7, 'atv', 'large']]],
            [
              'Sportsman 850 SP',
              [
                ['2015-2016', '296', 7, 'atv', 'large'],
                ['2018-2024', '333', 6, 'atv', 'large'],
              ],
            ],
            ['Sportsman 850 Touring SP', [['2015-2023', '381', 6, 'atv', 'large']]],
            ['Sportsman 90', [['2001-2006', '230', 0, 'atv', 'large']]],
            ['Sportsman Forest 550', [['2012-2014', '296', 7, 'atv', 'large']]],
            ['Sportsman Forest 850', [['2012-2014', '296', 7, 'atv', 'large']]],
            ['Sportsman Touring 1000', [['2015-2018', '381', 6, 'atv', 'large']]],
            ['Sportsman Touring Tractor 1000', [['2016-2023', '381', 6, 'atv', 'large']]],
            [
              'Sportsman XP 1000',
              [
                ['2016', '296', 7, 'atv', 'large'],
                ['2019-2024', '381', 6, 'atv', 'large'],
              ],
            ],
            ['Sportsman XP 550', [['2013-2014', '296', 7, 'atv', 'large']]],
            ['Sportsman XP 850', [['2012-2015', '296', 7, 'atv', 'large']]],
            [
              'Swedish Sportsman 500',
              [
                ['1996-1998', '218', 7, 'atv', 'large'],
                ['1996-1998', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Trail Blazer', [['1996-2006', '243', 7, 'atv', 'large']]],
            ['TrailBoss', [['1988-2001', '249', 6, 'atv', 'large']]],
            ['Trailblazer 250', [['2004-2006', '313', 6, 'atv', 'large']]],
            ['Trailboss 250', [['1988-1995', '249', 6, 'atv', 'large']]],
            ['Trailboss 325', [['2001', '249', 6, 'atv', 'large']]],
            [
              'Trailboss 330',
              [
                ['2004-2009', '269', 7, 'atv', 'large'],
                ['2008-2009', '218', 7, 'atv', 'large'],
                ['2008-2009', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Trailboss 350', [['1990-1992', '249', 6, 'atv', 'large']]],
            [
              'Worker 335',
              [
                ['1999', '218', 7, 'atv', 'large'],
                ['1999', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Worker 500',
              [
                ['1999-2001', '218', 7, 'atv', 'large'],
                ['1999-2001', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Xpedition 325',
              [
                ['2000-2002', '218', 7, 'atv', 'large'],
                ['2000-2002', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Xpedition 425',
              [
                ['2000-2002', '218', 7, 'atv', 'large'],
                ['2000-2002', '350', 8, 'atv', 'large'],
              ],
            ],
            ['Xplorer', [['2000-2001', '249', 6, 'atv', 'large']]],
            [
              'Xplorer 400L',
              [
                ['1995-1996', '218', 7, 'atv', 'large'],
                ['1995-1996', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Xplorer 500',
              [
                ['1997', '218', 7, 'atv', 'large'],
                ['1997', '350', 8, 'atv', 'large'],
              ],
            ],
            [
              'Xpress 300-400',
              [
                ['1997', '218', 7, 'atv', 'large'],
                ['1997', '350', 8, 'atv', 'large'],
              ],
            ],
          ],
        ],
        [
          'Suzuki',
          'SUZ',
          [
            ['ALT 125', [['1983-1986', '509', 7, 'atv', 'large']]],
            ['ALT 185', [['1985', '509', 7, 'atv', 'large']]],
            [
              'King Quad LT-F 250F',
              [
                ['1999-2001', '435', 6, 'atv', 'large'],
                ['1999-2002', '435', 6, 'atv', 'large'],
              ],
            ],
            ['King Quad LT-F 300F', [['1999-2002', '435', 6, 'atv', 'large']]],
            ['LT 125', [['1983-1987', '509', 7, 'atv', 'large']]],
            ['LT 160', [['2003-2004', '315', 5, 'atv', 'large']]],
            ['LT 160E', [['1989-1992', '315', 5, 'atv', 'large']]],
            ['LT 185', [['1984-1987', '509', 7, 'atv', 'large']]],
            ['LT 230E Quad Runner', [['1987-1993', '216', 6, 'atv', 'large']]],
            ['LT 230S Quad sport', [['1985-1988', '216', 6, 'atv', 'large']]],
            [
              'LT 250R',
              [
                ['1985-1986', '214', 6, 'atv', 'large'],
                ['1985-1992', '245', 6, 'atv', 'large'],
              ],
            ],
            ['LT 500R Quadzilla', [['1987-1990', '288', 5, 'atv', 'large']]],
            ['LT 80', [['1987-2006', '213', 5, 'atv', 'large']]],
            ['LT-400', [['2003-2008', '207', 7, 'atv', 'large']]],
            ['LT-400Z', [['2003-2008', '207', 7, 'atv', 'large']]],
            [
              'LT-A 450X Kingquad',
              [
                ['2007-2010', '265', 6, 'atv', 'large'],
                ['2007-2010', '266', 6, 'atv', 'large'],
              ],
            ],
            ['LT-A 500F', [['2002-2007', '356', 6, 'atv', 'large']]],
            [
              'LT-A 700X Kingquad',
              [
                ['2005-2007', '265', 6, 'atv', 'large'],
                ['2005-2007', '266', 6, 'atv', 'large'],
              ],
            ],
            [
              'LT-A 750X Kingquad',
              [
                ['2008-2018', '265', 6, 'atv', 'large'],
                ['2008-2018', '266', 6, 'atv', 'large'],
              ],
            ],
            ['LT-F 160', [['1993-2001', '315', 5, 'atv', 'large']]],
            ['LT-F 160T', [['1991-1996', '315', 5, 'atv', 'large']]],
            [
              'LT-F 250',
              [
                ['1988-1998', '366', 7, 'atv', 'large'],
                ['2002-2014', '528', 5, 'atv', 'large'],
              ],
            ],
            ['LT-F 4WD', [['1987-1998', '366', 7, 'atv', 'large']]],
            ['LT-F 500F', [['2003-2007', '356', 6, 'atv', 'large']]],
            ['LT-R 450', [['2006-2009', '194', 7, 'atv', 'large']]],
            ['LT-Z 250', [['2004-2009', '246', 7, 'atv', 'large']]],
            ['LT230GE', [['1985-1986', '510', 7, 'atv', 'large']]],
            ['LTF230', [['1986-1987', '510', 7, 'atv', 'large']]],
            ['LTZ 400', [['2009-2013', '240', 8, 'atv', 'large']]],
            ['LTZ 50', [['2006-2023', '236', 4, 'atv', 'large']]],
            ['LTZ 90', [['2007-2023', '237', 5, 'atv', 'large']]],
            [
              'Lt-A 500X Kingquad',
              [
                ['2009-2018', '265', 6, 'atv', 'large'],
                ['2009-2018', '266', 6, 'atv', 'large'],
              ],
            ],
            ['Suzuki LT-F 250 QuadRunner', [['1988-1998', '285', 6, 'atv', 'large']]],
            ['Twin Peaks LT-V 700F', [['2004-2005', '374', 7, 'atv', 'large']]],
          ],
        ],
        [
          'Yamaha',
          'YAM',
          [
            ['Badger 80', [['1992-2001', '447', 7, 'atv', 'large']]],
            ['Banshee', [['1988-2006', '112', 6, 'atv', 'large']]],
            ['Bear Tracker 250 YFM 250X', [['1999-2004', '486', 6, 'atv', 'large']]],
            ['Big Bear 250', [['2007-2009', '354', 6, 'atv', 'large']]],
            ['Big Bear 350 YFM 350', [['1987-1999', '272', 6, 'atv', 'large']]],
            ['Big Bear 400', [['2000-2012', '270', 6, 'atv', 'large']]],
            ['Blaster 200', [['1988-2006', '178', 5, 'atv', 'large']]],
            ['Breeze 125', [['1989-2004', '496', 7, 'atv', 'large']]],
            ['Bruin 250', [['2005-2006', '354', 6, 'atv', 'large']]],
            ['Bruin 350', [['2004-2006', '354', 6, 'atv', 'large']]],
            ['Champ YFM 100', [['1987-1991', '447', 7, 'atv', 'large']]],
            ['Grizzly 110', [['2025', '508', 5, 'atv', 'large']]],
            ['Grizzly 350', [['2007-2014', '354', 6, 'atv', 'large']]],
            ['Grizzly 450', [['2007-2014', '354', 6, 'atv', 'large']]],
            ['Grizzly 550', [['2009-2014', '351', 5, 'atv', 'large']]],
            ['Grizzly 600', [['1998-2001', '382', 5, 'atv', 'large']]],
            ['Grizzly 660', [['2002-2008', '479', 5, 'atv', 'large']]],
            [
              'Grizzly 700',
              [
                ['2007-2015', '351', 5, 'atv', 'large'],
                ['2016-2025', '344', 5, 'atv', 'large'],
              ],
            ],
            ['Grizzly 90', [['2021-2024', '508', 5, 'atv', 'large']]],
            ['Kodiak  YFM 400', [['1996-1999', '523', 7, 'atv', 'large']]],
            ['Kodiak 400', [['2003-2006', '354', 6, 'atv', 'large']]],
            [
              'Kodiak 450',
              [
                ['2003-2006', '354', 6, 'atv', 'large'],
                ['2018-2025', '525', 5, 'atv', 'large'],
              ],
            ],
            ['Kodiak 700', [['2016-2025', '525', 5, 'atv', 'large']]],
            ['Moto-4 YFM 225', [['1986-1988', '261', 7, 'atv', 'large']]],
            ['Moto-4 YFM 250', [['1989-1991', '261', 7, 'atv', 'large']]],
            ['Moto-4 YFM 350', [['1987-1995', '261', 7, 'atv', 'large']]],
            ['Raptor 125', [['2011-2013', '221', 6, 'atv', 'large']]],
            ['Raptor 250', [['2008-2013', '221', 6, 'atv', 'large']]],
            ['Raptor 350', [['2004-2013', '242', 6, 'atv', 'large']]],
            ['Raptor 50', [['2004-2008', '295', 5, 'atv', 'large']]],
            ['Raptor 660', [['2001-2005', '199', 6, 'atv', 'large']]],
            ['Raptor 660R', [['2001-2005', '199', 6, 'atv', 'large']]],
            ['Raptor 700', [['2006-2025', '193', 6, 'atv', 'large']]],
            ['Raptor 700R', [['2006-2025', '193', 6, 'atv', 'large']]],
            ['Raptor 80', [['2002-2008', '295', 5, 'atv', 'large']]],
            ['Raptor 90', [['2009-2013', '290', 5, 'atv', 'large']]],
            ['Terra Pro YFP350', [['1988', '512', 0, 'atv', 'large']]],
            ['Timberwolf 250', [['1992-2000', '485', 6, 'atv', 'large']]],
            ['Warrior', [['1988-2004', '111', 7, 'atv', 'large']]],
            ['Wolverine YFM35FX', [['1995-2005 ', '476', 6, 'atv', 'large']]],
            ['YFB250', [['1993-1997', '485', 6, 'atv', 'large']]],
            ['YFZ 450', [['2004-2013', '200', 7, 'atv', 'large']]],
            ['YFZ 450R', [['2009-2025', '201', 7, 'atv', 'large']]],
            ['YFZ 450X', [['2010-2011', '201', 7, 'atv', 'large']]],
            ['YFZ 50', [['2017-2024', '212', 4, 'atv', 'large']]],
            ['YTM 200 3 Wheeler', [['1983-1985', '209', 7, 'atv', 'large']]],
          ],
        ],
      ],
    },

    {
      name: 'eBikes',
      identifier: { name: 'eBikes', index: 2 },
      id: [36685],
      testingId: [80030],
      ribNumber: [1, 2, 3, 4, 5, 6],
      midPanel: false,
      badges: [
        { name: 'enjoyMfg', label: 'enjoyMfg', mode: 'enjoyMfg', abrv: 'ENJ' },
        { name: 'bolt', mode: 'bolt', label: 'Bolt', abrv: 'BLT' },
        { name: 'none', mode: 'none', label: 'None', abrv: 'None' },
      ],
      newBadge: true,
      make: [
        [
          'Alta',
          'ALTA',
          [['Redshift MX', [['2017-2019', '217', 5, 'motorcycle', 'large']]]],
        ],
        [
          'Altis Sigma',
          'AS',
          [['Altis Sigma', [['All years', '480', 6, 'ebike2', 'large']]]],
        ],
        [
          'Ampd Bros',
          'AMP',
          [
            ['Ace Dual', [['All years', '542', 5, 'motorcycle', 'large']]],
            ['Lil Rippa', [['All years', '547', 5, 'ebike2', 'large']]],
          ],
        ],
        ['Amyet', 'AMY', [['V9-G60', [['All years', '520', 4, 'motorcycle', 'large']]]]],
        [
          'Aniioki',
          'ANI',
          [
            ['A8 Pro Max', [['All years', '543', 4, 'ebike2', 'large']]],
            ['A9 Pro Max', [['All years', '543', 4, 'ebike2', 'large']]],
          ],
        ],
        [
          'Arctic Leopard',
          'ARL',
          [
            ['EX 800', [['All years', '531', 7, 'motorcycle', 'large']]],
            ['EXE 880', [['All years', '532', 8, 'motorcycle', 'large']]],
            ['XE Pro', [['All years', '533', 8, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Ariel Rider',
          'ARR',
          [['X Class', [['All years', '402', 3, 'ebike2', 'large']]]],
        ],
        ['Drift.Slide', 'DRI', [['J1', [['All years', '503', 3, 'ebike2', 'large']]]]],
        ['E-Ride', 'E-R', [['Pro', [['All years', '433', 5, 'ebike2', 'large']]]]],
        [
          'EBOX',
          'EBO',
          [
            ['EBOX 1', [['All years', '497', 5, 'ebike2', 'large']]],
            ['EBOX 2 V2', [['All years', '497', 5, 'ebike2', 'large']]],
            ['EBOX 3 MX', [['All years', '497', 5, 'ebike2', 'large']]],
            ['EBOX 3 SM', [['All years', '497', 5, 'ebike2', 'large']]],
          ],
        ],
        [
          'Electro & Co',
          'ELE',
          [['ETM RTR', [['All years', '534', 6, 'motorcycle', 'large']]]],
        ],
        ['Himiway', 'HIM', [['C5', [['All years', '441', 6, 'motorcycle', 'large']]]]],
        [
          'Kuberg',
          'KUB',
          [
            ['Cross', [['All years', '393', 4, 'ebike2', 'large']]],
            ['Cross Hero', [['All years', '393', 4, 'ebike2', 'large']]],
            ['X-Force Pro 50', [['All years', '393', 4, 'ebike2', 'large']]],
          ],
        ],
        [
          'Macfox',
          'MAC',
          [
            ['X1S', [['All years', '482', 6, 'ebike1', 'large']]],
            ['X2', [['All years', '482', 6, 'ebike1', 'large']]],
            ['X7', [['All years', '482', 6, 'ebike1', 'large']]],
            ['X7L', [['All years', '482', 6, 'ebike1', 'large']]],
            
          ],
        ],
        ['Onyx', 'ONY', [['RCR / CYT', [['All years', '392', 4, 'ebike2', 'large']]]]],
        [
          'Pedal',
          'PED',
          [
            ['AWD', [['All years', '390', 3, 'ebike2', 'large']]],
            ['AWD III', [['All years', '390', 3, 'ebike2', 'large']]],
            ['Core', [['All years', '390', 3, 'ebike2', 'large']]],
            ['Core 2.0', [['All years', '390', 3, 'ebike2', 'large']]],
          ],
        ],
        [
          'RAEV',
          'RAE',
          [
            ['Bullet', [['All years', '491', 4, 'motorcycle', 'large']]],
            ['Bullet GT V2', [['All years', '491', 4, 'motorcycle', 'large']]],
          ],
        ],
        [
          'RFN',
          'RFN',
          [
            ['Ares Endurance Pro', [['All years', '546', 6, 'motorcycle', 'large']]],
            ['Ares Rally', [['All years', '546', 6, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Rawrr',
          'RAR',
          [
            ['72V Mantis', [['All years', '554', 3, 'motorcycle', 'large']]],
            ['72V Mantis Flat Seat', [['All years', '553', 6, 'motorcycle', 'large']]],
            ['Mantis Mini R', [['All years', '537', 5, 'ebike2', 'large']]],
            ['Mantis X', [['All years', '536', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Razor',
          'RAZ',
          [
            ['MX 650', [['All years', '505', 5, 'ebike2', 'large']]],
            ['Rambler 20', [['All years', '507', 6, 'motorcycle', 'large']]],
            ['Stage2 M1 E Moto', [['All years', '545', 6, 'motorcycle', 'large']]],
          ],
        ],
        ['Rerode', 'RER', [['R1', [['All years', '535', 5, 'ebike2', 'large']]]]],
        [
          'Ride1Up',
          'RID',
          [
            ['Revv1 FS', [['All years', '563', 4, 'ebike2', 'large']]],
            ['Revv1 HT', [['All years', '563', 4, 'ebike2', 'large']]],
          ],
        ],
        [
          'Riding Times',
          'RIT',
          [
            ['GT73', [['All years', '540', 7, 'motorcycle', 'large']]],
            ['GT73 Pro', [['All years', '540', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Ridstar',
          'RI',
          [
            ['Q20', [['All years', '477', 5, 'ebike1', 'large']]],
            ['Q20 Light', [['All years', '477', 5, 'ebike1', 'large']]],
            ['Q20 Pro', [['All years', '477', 5, 'ebike1', 'large']]],
          ],
        ],
        [
          'Ripz Moto',
          'RIP',
          [['R110 PRO V2', [['All years', '493', 5, 'motorcycle', 'large']]]],
        ],
        [
          'SWFT',
          'SWF',
          [['Zip 500W Fat Tire', [['All years', '538', 5, 'motorcycle', 'large']]]],
        ],
        [
          'Stacyc',
          'STA',
          [['20HDRIVE Class 2', [['All years', '494', 6, 'motorcycle', 'large']]]],
        ],
        [
          'Stark Varg',
          'STR',
          [['Stark Varg', [['All years', '406', 8, 'motorcycle', 'large']]]],
        ],
        [
          'Super 73',
          'S73',
          [
            ['Brooklyn R-Series', [['All years', '434', 3, 'motorcycle', 'large']]],
            ['CAFÉ RACER 3" FOAM       ', [['All years', '424', 5, 'ebike2', 'large']]],
            ['Indian', [['All years', '459', 7, 'motorcycle', 'large']]],
            ['Stock 1-Up / S1/S2/R/RX', [['All years', '365', 4, 'ebike2', 'large']]],
            ['Stock 2-Up / S1/S2/R/RX', [['All years', '367', 5, 'motorcycle', 'large']]],
            ['X RSD RX MALIBU EDITION', [['All years', '403', 7, 'motorcycle', 'large']]],
            ['ZX / Z Miami / Z1', [['All years', '378', 6, 'ebike1', 'large']]],
          ],
        ],
        [
          'Surron',
          'SUR',
          [
            ['Hyper Bee', [['2025', '500', 4, 'ebike2', 'large']]],
            ['Light Bee 4MF Kit', [['All years', '389', 7, 'motorcycle', 'large']]],
            ['Light Bee MX & X', [['All years', '349', 4, 'ebike2', 'large']]],
            ['Light Bee Race Spec', [['All years', '399', 6, 'motorcycle', 'large']]],
            ['Luna Float MX & X', [['All years', '348', 4, 'ebike2', 'large']]],
            ['SurRon Shop Extended', [['All years', '396', 5, 'ebike2', 'large']]],
            ['Ultra Bee', [['All years', '388', 8, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Talaria',
          'TAL',
          [
            ['Luna Float XXX', [['All years', '495', 6, 'motorcycle', 'large']]],
            ['Sting', [['All years', '362', 5, 'ebike2', 'large']]],
            ['XXX', [['All years', '407', 6, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Tamobyke',
          'TAM',
          [
            ['V20', [['All years', '466', 5, 'ebike1', 'large']]],
            ['V20 Pro', [['All years', '466', 5, 'ebike1', 'large']]],
          ],
        ],
        [
          'Throne',
          'THR',
          [
            ['SRPNT', [['All years', '475', 7, 'motorcycle', 'large']]],
            ['SRPNT X3', [['All years', '475', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Tuttio',
          'TUT',
          [
            ['ICT', [['All years', '504', 4, 'ebike2', 'large']]],
            ['Soleil01', [['All years', '492', 6, 'motorcycle', 'large']]],
          ],
        ],
        ['Victrip', 'VIC', [['R6', [['All years', '552', 5, 'ebike1', 'large']]]]],
        [
          'Zooz',
          'ZO',
          [
            ['UF1200', [['All years', '391', 7, 'motorcycle', 'large']]],
            ['UU1100', [['All years', '391', 7, 'motorcycle', 'large']]],
            ['UU750', [['All years', '391', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Zugo',
          'ZUG',
          [
            ['Step Over', [['All years', '564', 6, 'motorcycle', 'large']]],
            ['Step Through', [['All years', '564', 6, 'motorcycle', 'large']]],
          ],
        ],
      ],
    },

    {
      identifier: { name: 'Scooters', index: 3 },

      id: [36683],
      testingId: [80031],

      ribNumber: [1, 2, 3, 4, 5, 6],
      midPanel: false,

      badges: [
        { name: 'enjoyMfg', label: 'enjoyMfg', mode: 'enjoyMfg', abrv: 'ENJ' },

        { name: 'Bolt', mode: 'bolt', label: 'Bolt', abrv: 'BLT' },
        { mode: 'yamaha', label: 'Yamaha', name: 'Yamaha', abrv: 'YAM' },
        { mode: 'kawasaki', label: 'Kawasaki', name: 'Kawasaki', abrv: 'KAW' },
        { mode: 'honda', label: 'Honda', name: 'Honda', abrv: 'HON' },
        { mode: 'none', label: 'None', name: 'None', abrv: 'None' },
      ],
      newBadge: true,

      make: [
        [
          'Honda',
          'HON',
          [
            ['Aero 50', [['1983-1984', '572', 4, 'scooter', 'large']]],
            ['Aero NB 50', [['1985-1987', '567', 5, 'scooter', 'large']]],
            ['CH80 Elite 80', [['1985-2007', '530', 6, 'scooter', 'large']]],
            ['Dio 1 AF18 AF25', [['All years', '570', 6, 'scooter', 'large']]],
            ['Dio 2 AF27 AF28 SR ZX', [['All years', '569', 5, 'scooter', 'large']]],
            ['GROM', [['2022-2026', '331', 6, 'scooter', 'large']]],
            [
              'Grom MSX 125',
              [
                ['2013-2015', '116', 5, 'scooter', 'large'],
                ['2016-2021', '177', 5, 'scooter', 'large'],
              ],
            ],
            ['NB 50', [['1983-1984', '572', 4, 'scooter', 'large']]],
            ['Navi', [['2022-2025', '363', 7, 'scooter', 'large']]],
            ['Ruckus', [['2003-2025', '346', 4, 'scooter', 'large']]],
            ['SA50 Elite 50', [['1988-2001', '541', 5, 'scooter', 'large']]],
            ['Spree NQ50', [['1984-1987', '550', 4, 'scooter', 'large']]],
          ],
        ],
        [
          'Kawasaki',
          'KAW',
          [['Z 125 Pro', [['2017-2025', '171', 7, 'scooter', 'large']]]],
        ],
        [
          'Yamaha',
          'YAM',
          [
            ['JOG CY50', [['1992-2001', '502', 4, 'scooter', 'large']]],
            ['Jog CG 50', [['1988-1991', '559', 4, 'scooter', 'large']]],
            ['LC50 Champ', [['1980-1981', '565', 3, 'scooter', 'large']]],
            ['QT 50', [['1979-1992', '566', 3, 'scooter', 'large']]],
            ['Razz SH50', [['1987-2001', '548', 4, 'scooter', 'large']]],
            ['Towny MJ50', [['1980-1982', '561', 4, 'scooter', 'large']]],
            [
              'Zuma 125',
              [
                ['2009-2015', '573', 7, 'scooter', 'large'],
                ['2016-2021', '571', 7, 'scooter', 'large'],
                ['2022-2025', '574', 3, 'scooter', 'large'],
              ],
            ],
            [
              'Zuma 50',
              [
                ['2002-2011', '549', 7, 'scooter', 'large'],
                ['2012-2013', '557', 3, 'scooter', 'large'],
              ],
            ],
            ['Zuma 50 CW50 SINGLE LOW', [['1989', '551', 4, 'scooter', 'large']]],
            ['Zuma 50F', [['2014-2019', '557', 3, 'scooter', 'large']]],
            ['Zuma 50FX', [['2014-2018', '557', 3, 'scooter', 'large']]],
            ['Zuma 50X', [['2015', '557', 3, 'scooter', 'large']]],
            ['Zuma BWS 50', [['2002-2004', '558', 6, 'scooter', 'large']]],
            ['Zuma II Double High', [['1997-2001', '555', 6, 'scooter', 'large']]],
            ['Zuma II Double Low', [['1997-2001', '556', 6, 'scooter', 'large']]],
          ],
        ],
      ],
    },
  ],
})

export { enjoyProductChoices }
